const ADD_BUTTON: string = 'add';
const ICON_BROWSE: string = 'icon-browse';
const ICON_SEARCH: string = 'icon-search';
const NO_ICON_SEARCH: string = 'no-icon-search';

export { ADD_BUTTON, ICON_BROWSE, ICON_SEARCH, NO_ICON_SEARCH };
